var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,512) scale(0.1,-0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5110,3370c-44,274-219,513-465,635c-157,78-211,86-584,94l-324,6l-14,70c-71,350-311,660-640,824c-76,38-187,76-285,97 c-86,19-318,27-402,14c-505-80-900-451-1000-941l-13-64l-324-6c-373-8-428-16-584-94c-171-86-302-218-385-390 c-92-190-84-59-88-1529C0,935,1,777,15,702c33-172,102-307,223-434C366,134,507,56,684,19C771,1,855,0,2556,0 c1577,0,1791,2,1864,16c171,32,305,101,432,222c134,128,212,269,249,446c18,86,19,159,19,1356C5120,2856,5116,3328,5110,3370z  M1020,340H913c-60,0-136,7-171,15c-191,45-342,196-387,387c-13,54-15,245-15,1299c0,839,3,1254,11,1295c34,187,183,349,369,400 c25,7,102,13,173,13l127,1V340z M1806,4320c119,230,343,396,602,445c100,19,262,13,366-14c230-60,432-222,543-436 c38-74,73-170,73-202c0-11-150-13-830-13s-830,2-830,13C1730,4145,1765,4242,1806,4320z M3750,340h-340v1.3 c-104.3-0.4-226-0.4-340,0V340H2050v1c-116.4-0.1-238.3,0.3-340,1v-2h-340v3410h219.2c163.3,2.6,508.6,2,723.4,0H2869 c197,2.1,548.6,2.3,734.3,0H3750V340z M4766,749c-41-192-195-348-388-394c-35-8-111-15-170-15h-108v3410h123c67,0,142-5,167-11 c183-42,345-214,379-403c8-41,11-455,11-1290C4780,1028,4777,804,4766,749z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.588feea4f61609255fa68606ab530f53.svg";
export { ForwardRef as ReactComponent };